import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientService } from './httpclient';
import { environment } from '../../../environments/environment';
import { encodePlanningPeriodBoundary } from '../functions/planning-period.functions';

@Injectable()
export class TruckAgendaService {

  constructor(private http: HttpClientService) { }

  getTruckAgenda(startDate: any, endDate: any, group: string, zone: string) {
    const timeFrom = encodePlanningPeriodBoundary(startDate, "start");
    const timeUntil = encodePlanningPeriodBoundary(endDate, "end");
    return this.http.get(environment.tmsApiEndpointAddress + 'truckagenda' + '?timeFrom=' + timeFrom
        + "&timeUntil=" + timeUntil + '&group=' + group + '&zone=' + zone).pipe(
      map((response: any) => response.data));
  }

  getAvailableDriversForTruck(group, zone, haulierNo){
    return this.http.get(environment.tmsApiEndpointAddress + 'truckagenda/drivers' +'?planningGroup=' + group
       + '&planningZone=' + zone + '&haulierNo=' + haulierNo).pipe(
      map((response: any) => response.data));
  }

  addDriverAssignment(capacity){
    return this.http.post(environment.tmsApiEndpointAddress + "truckagenda/capacity", capacity).pipe(
      map((response: any) => response.data));
  }

  removeDriverAssignment(capacity) {
    return this.http.post(environment.tmsApiEndpointAddress + "truckagenda/unassign-driver", capacity).pipe(
      map((response: any) => response.data));
  }

  updateDriverAssignment(capacityId, capacity){
    return this.http.put(environment.tmsApiEndpointAddress + "truckagenda/capacity/" + capacityId, capacity).pipe(
      map((response: any) => response.data));
  }

  deleteDriverAssignment(capacityId){
    return this.http.delete(environment.tmsApiEndpointAddress + "truckagenda/capacity/" + capacityId).pipe(
      map((response: any) => response.data));
  }

  getCausesOfUnavaiability(){
    return this.http.get(environment.tmsApiEndpointAddress + "truckagenda/unavailability/causes/").pipe(
      map((response: any) => response.data));
  }

  registerUnavailability(unavailability){
    return this.http.post(environment.tmsApiEndpointAddress + "truckagenda/unavailability", unavailability).pipe(
      map((response: any) => response.data));
  }

  updateTruckUnavailability(unavailabilityId, unavailability){
    return this.http.put(environment.tmsApiEndpointAddress + "truckagenda/unavailability/" + unavailabilityId, unavailability).pipe(
      map((response: any) => response.data));
  }

  deleteTruckUnavailability(unavailabilityId){
    return this.http.delete(environment.tmsApiEndpointAddress + "truckagenda/unavailability/" + unavailabilityId).pipe(
      map((response: any) => response.data));
  }
}
